import { useEffect, useState } from 'react';
/** Confirm the durable outbox, not a comparison between unrelated client/server revision clocks. */
export function useLibrarySyncStatus(maps, signedIn, pending) {
    const [states, setStates] = useState({});
    useEffect(() => {
        let cancelled = false;
        const active = () => !cancelled;
        void (async () => {
            const next = {};
            for (const { map } of maps) {
                if (!active())
                    return;
                if (!signedIn) {
                    next[map.id] = 'local';
                    continue;
                }
                if (map.serverRevision === 0) {
                    next[map.id] = 'pending';
                    continue;
                }
                try {
                    next[map.id] = await pending(map.id) ? 'pending' : 'sent';
                }
                catch {
                    next[map.id] = 'unavailable';
                }
            }
            if (active())
                setStates(next);
        })();
        return () => { cancelled = true; };
    }, [maps, signedIn, pending]);
    return states;
}
//# sourceMappingURL=library-sync-status.js.map